<template>
  <div class="popup-info">
    <i class="fa-solid fa-xmark" @click="info.setInvisible(), info.emptyAllExceptGewaesser()"></i>
    <table v-if="info?.gewaesser" class="popup-table">
      <Accordion :initShow="true">
        <template v-slot:heading>
          <span class="popup-heading" v-text="`Gewässer '${info.gewaesser.getId()}'`"></span>
        </template>
        <tr>
          <td>Bezeichnung: </td><td v-text="info.gewaesser.get('name')"></td>
        </tr>
        <tr v-if="info.getGewaesserKm()">
          <td>Km an Klick: </td><td> {{ info.getGewaesserKm() }}</td>
        </tr>
        <tr v-if="info.getAbfluss()">
          <td>Abfluss an Klick: </td>
          <td> 
            <tr v-for="series in Object.keys(info.getAbfluss())">
              <td v-if="info.getAbfluss()[series]">{{ series }}:</td>
              <td v-if="info.getAbfluss()[series]">
                <tr v-for="val in info.getAbfluss()[series]">
                  <td>{{ val.toLocaleString("de-DE", {minimumFractionDigits: 2}) }} m³/s</td>
                </tr>
              </td>
            </tr>
          </td>
        </tr>
      </Accordion>
    </table>
    <table v-for="(item, index) in info?.transportelemente" :key="index" class="popup-table">
      <Accordion :initShow="true" >
        <template v-slot:heading>
          <span class="popup-heading" v-text="`${item?.get('ID_TE_Typ')} '${item?.get('ID_SEBezeichnung')}'`"></span>
        </template>
        <tr>
          <td>Bezeichnung: </td><td v-text="item?.get('ID_TE_Bezeichnung')"></td>
        </tr>
        <tr v-if="item?.get('ID_SEKommentar')">
          <td>Kommentar an Systemelement: </td><td v-text="item?.get('ID_SEKommentar')"></td>
        </tr>
        <tr>
          <td colspan="2" style="max-width:200px">
            <label class="switch">
              <input type="checkbox" v-model="checkedTEForEinzugsgebiet" @change="showEinzugsgebiet(item?.get('ID_SEBezeichnung'), Constants.SETypen.Transportelement)" :value="item?.get('ID_SEBezeichnung')">
              <span class="slider round"></span>
            </label>
            Einzugsgebiet anzeigen
          </td>
        </tr>
      </Accordion> 
    </table>
    <EinzugsgebietInfo v-if="info?.einzugsgebiet?.type == Constants.SETypen.Transportelement" :einzugsgebiet="info?.einzugsgebiet"></EinzugsgebietInfo>
    <table v-for="(item, index) in info?.bauwerke" :key="index" class="popup-table">
      <Accordion :initShow="true">
        <template v-slot:heading>
          <span class="popup-heading" v-text="`${item?.get('ID_TE_Typ')} '${item?.get('ID_SEBezeichnung')}'`"></span>
        </template>
        <tr>
          <td>Bezeichnung: </td><td v-text="item?.get('ID_TE_Bezeichnung')"></td>
        </tr>
        <tr v-if="item?.get('ID_TE_SpeicherDrosselBeiStauziel')">
          <td>Drossel bei Stauziel: </td><td>{{ item?.get('ID_TE_SpeicherDrosselBeiStauziel')?.toLocaleString("de-DE", {minimumFractionDigits: 2}) }}	m³/s</td>
        </tr>
        <tr v-if="item?.get('ID_TE_SpeicherVolumen')">
          <td>Gesamtvolumen: </td><td>{{ item?.get('ID_TE_SpeicherVolumen')?.toLocaleString("de-DE", {minimumFractionDigits: 2}) }} Tm³</td>
        </tr>
        <tr v-if="item?.get('ID_SEKommentar')">
          <td>Kommentar an Systemelement: </td><td v-text="item?.get('ID_SEKommentar')"></td>
        </tr>
        <tr>
          <td colspan="2" style="max-width:200px">
            <label class="switch">
              <input type="checkbox" v-model="checkedTEForEinzugsgebiet" @change="showEinzugsgebiet(item?.get('ID_SEBezeichnung'), Constants.SETypen.Bauwerk)" :value="item?.get('ID_SEBezeichnung')">
              <span class="slider round"></span>
            </label>
            Einzugsgebiet anzeigen
          </td>
        </tr>
      </Accordion>
    </table>
    <EinzugsgebietInfo v-if="info?.einzugsgebiet?.type == Constants.SETypen.Bauwerk" :einzugsgebiet="info?.einzugsgebiet"></EinzugsgebietInfo>
    <table v-for="(item, index) in info?.teilgebiete" :key="index" class="popup-table">
      <Accordion :initShow="true">
        <template v-slot:heading>
          <span class="popup-heading" v-text="`${item?.get('ID_TG_Typ')} '${item?.get('ID_SEBezeichnung')}'`"></span>
        </template>
        <tr v-if="item?.get('ID_TG_Bezeichnung') && item?.get('ID_TG_Bezeichnung') !== ''">
          <td>Bezeichnung: </td><td v-text="item?.get('ID_TG_Bezeichnung')"></td>
        </tr>
        <tr v-if="item?.get('ID_TG_Groesse_ha')">
          <td>Größe: </td><td> {{ item?.get('ID_TG_Groesse_ha')?.toLocaleString("de-DE", {minimumFractionDigits: 2}) }} ha</td>
        </tr>
        <tr v-if="item?.get('ID_SEKommentar')">
          <td>Kommentar an Systemelement: </td><td v-text="item?.get('ID_SEKommentar')"></td>
        </tr>
      </Accordion>
    </table>
    <table v-for="(item, index) in info?.kanalisierteFlaechen" :key="index" class="popup-table">
      <Accordion :initShow="true">
        <template v-slot:heading>
          <span class="popup-heading" v-text="`${item?.get('ID_TG_Typ')} '${item?.get('ID_SEBezeichnung')}'`"></span>
        </template>
        <tr v-if="item?.get('ID_TG_Bezeichnung') && item?.get('ID_TG_Bezeichnung') !== ''">
          <td>Bezeichnung: </td><td v-text="item?.get('ID_TG_Bezeichnung')"></td>
        </tr>
        <tr v-if="item?.get('ID_TG_Groesse_ha')">
          <td>Größe: </td><td> {{ item?.get('ID_TG_Groesse_ha')?.toLocaleString("de-DE", {minimumFractionDigits: 2}) }} ha</td>
        </tr>
        <tr>
          <td>Entwässerungssystem: </td><td> {{ item?.get('ID_TGQTMode') }} </td>
        </tr>
        <tr v-if="item?.get('ID_TGEinwohner') && item?.get('ID_TGEinwohner') !== 0">
          <td>Einwohner: </td><td>{{ item?.get('ID_TGEinwohner')?.toLocaleString("de-DE") }}</td>
        </tr>
        <tr v-if="item?.get('ID_TG_AnteilVersieglungRO')">
          <td>Anteil vers. Fläche: </td><td>{{ item?.get('ID_TG_AnteilVersieglungRO')?.toLocaleString("de-DE", {style: 'percent', minimumFractionDigits: 2}) }}</td>
        </tr>
        <tr v-if="item?.get('ID_SEKommentar')">
          <td>Kommentar an Systemelement: </td><td v-text="item?.get('ID_SEKommentar')" ></td>
        </tr>
      </Accordion>
    </table>
  </div>
</template>

<script lang="ts">

import { onMounted, ref, computed, watch } from 'vue';
import Constants from './Constants';
import Accordion from "../../../vueforms/src/components/base/Accordion.vue";
import { ClickInfo } from './ClickInfo';
import EinzugsgebietInfo from './EinzugsgebietInfo.vue';

export default {
  props: {
    info: ClickInfo
  },
  components: {
    Accordion,
    EinzugsgebietInfo
  },
  emits: [
    "showEinzugsgebiet",
    "hideEinzugsgebiet",
  ],
  setup(props, {emit}){

    onMounted(() => {
      
    });
    let checkedTEForEinzugsgebiet = ref([]);
    //let checkedBWForSystemplan = ref([]);
    const showEinzugsgebiet = (SEBezeichnung: string, seTyp: number) => {
      //schalter wurde auf off getoggelt.
      if (checkedTEForEinzugsgebiet.value.length === 0) {
        emit("hideEinzugsgebiet");
        return;
      }
      //schalter wurde an getoggelt -> alle anderen off schalten
      checkedTEForEinzugsgebiet.value = [SEBezeichnung];
      emit("showEinzugsgebiet", SEBezeichnung, seTyp);
    }

    //Wenn ein neues Info übergeben wurde wegen eines Klicks in Map (und nicht wegen einer weiterführenden Aktion) sollten
    // alle Toggle Schalter wieder auf off geschaltet werden
    watch(() => props.info, (newVal) => { 
      if (!newVal.weiterfuehrendeAktion) {
        checkedTEForEinzugsgebiet.value = [];
        //checkedBWForSystemplan.value = [];
      }
    }, { deep: true })

    return {
      Constants,
      showEinzugsgebiet,
      checkedTEForEinzugsgebiet,
    }

  }
}
</script>